class Podcast {
	/**
	 * Делает кнопки активными
	 *
	 * @memberof Podcast
	 */
	static #undisableButton() {
		this.slowButton.disabled = false;
		this.fastButton.disabled = false;
	}

	/**
	 * Ускоряет воспроизведение
	 *
	 * @memberof Podcast
	 */
	static #fast() {
		this.#undisableButton();
		if (this.playbackRate < 2) {
			this.playbackRate += 0.25;
			this.audioElement.playbackRate = this.playbackRate;
		}

		if (this.playbackRate >= 2) {
			this.fastButton.disabled = true;
		}
	}

	/**
	 * Замедляет воспроизведение
	 *
	 * @memberof Podcast
	 */
	static #slow() {
		this.#undisableButton();
		if (this.playbackRate > 0.25) {
			this.playbackRate -= 0.25;
			this.audioElement.playbackRate = this.playbackRate;
		}

		if (this.playbackRate <= 0.25) {
			this.slowButton.disabled = true;
		}
	}

	static init(root) {
		let player = null;

		if (root) {
			player = root.querySelector('.player');
		} else {
			player = document.querySelector('.player');
		}

		if (player) {
			this.playbackRate = 1;
			this.audioElement = player.querySelector('.player__audio');
			this.fastButton = player.querySelector('button#fast');
			this.slowButton = player.querySelector('button#slow');

			this.fastButton.addEventListener('click', this.#fast.bind(this));
			this.slowButton.addEventListener('click', this.#slow.bind(this));
		}
	}
}

export default Podcast;
